<template>
  <div class="wl-project-introduction">
      <div class="wl-certification-content">
        <router-view></router-view>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      isTab: 1,
      back: require("assets/images/bg-hd.png"),
      TeaAuthenticaList: []
    };
  },

  created() {},
  methods: {
    goHome() {
      this.$router.push({
        name: "xHome"
      });
    }
  }
};
</script>
